import React, { Component } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import { history } from "../../_helpers";
import { api } from "../../_services";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import DeviceCard from "../DeviceCard";
import PrecinctDropdown from "../PrecinctDropdown";
import SensorTypeCheckBox from "../SensorTypeCheckBox";
import DeviceStatusCheckBox from "../DeviceStatusCheckBox";
import Pagination from "../Pagination";
import _ from "lodash";
import { sensorList, sensorOn, sidebarOff, pageDevices, modalAlert } from "../../_actions";

import "react-table/react-table.css";
import "./index.css";
import { Row, Col, form, Button, FormGroup, ControlLabel, FormControl } from "react-bootstrap";

class AllSensorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      devicesList: [],
      pages: null,
      currentPage: 1,
      loading: false,
      filterOpen: false,
      resetFilter: false,
      listLoading: false,
      filtered: false,
      showIDInput: false,
      params: {}
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        loading: true
      };
    });
    this.props.sidebarOff();
    //set current page to devices
    this.props.pageDevices();

    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search);
      this.getAllSensors(params);
    } else {
      this.getAllSensors();
    }
    this.setCurrentPage(true);
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.location.search !== nextProps.location.search && nextProps.location.search === "") {
      this.resetFilter();
    }
  };

  setCurrentPage = val => {
    localStorage.setItem("currentDevicePageType", JSON.stringify({ list: val }));
  };

  /* Retrieve all devices */
  getAllSensors = p => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/devices/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
      this.setState(() => {
        return {
          params: params,
          showIDInput: params.id ? true : false
        };
      });
    } else {
      // clear the url params
      if (this.props.location.search) {
        history.push({
          pathname: this.props.location.pathname,
          search: ""
        });
      }
    }
    const errorMsg = "Unable to retrieve devices.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      const filtered = this.checkFiltered();
      this.setState(() => {
        return {
          devicesList: json.results,
          count: json.count,
          page_size: json.page_size,
          num_pages: json.num_pages,
          current_page: json.current_page,
          loading: false,
          listLoading: false,
          filtered: filtered
        };
      });
    });
  };

  filterDevice = (reset, page) => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/devices/";
    const params = {};
    if (!reset) {
      if (!this.state.params.id) {
        this.setState(() => {
          return {
            showIDInput: false
          };
        });
      }

      for (const key in this.state.params) {
        if (this.state.params[key] !== "") {
          params[key] = this.state.params[key];
        }
      }

      if (page) {
        params.page = page;
      } else {
        delete params["page"];
      }
    }
    if (this.checkFiltered() || !reset) {
      const errorMsg = "Unable to retrieve devices.";
      let filtered = false;

      filtered = this.checkFiltered();

      api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
        this.setState(() => {
          return {
            devicesList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            loading: false,
            listLoading: false,
            filtered: filtered ? true : false
          };
        });
      });
      this.openFilter(false);
    } else if (reset) {
      this.setState(() => {
        return {
          loading: false,
          filtered: reset ? false : true
        };
      });
    }

    const queryParams = api.queryParams(params);
    if (queryParams) {
      history.push({
        pathname: this.props.location.pathname,
        search: "?" + queryParams
      });
    } else {
      history.push({
        pathname: this.props.location.pathname,
        search: ""
      });
    }
  };

  checkFiltered = () => {
    let filtered = false;
    for (const key in this.state.params) {
      if (Array.isArray(this.state.params[key]) && this.state.params[key].length > 0) {
        filtered = true;
      } else if (this.state.params[key]) {
        filtered = true;
      }
    }
    return filtered;
  };

  createDeviceCard = (item, key) => {
    return <DeviceCard key={key} item={item} />;
  };

  openFilter = opened => {
    if (opened) {
      this.setState(() => {
        return {
          filterOpen: true
        };
      });
    } else {
      this.setState(() => {
        return {
          filterOpen: false
        };
      });
    }
  };

  setStatus = val => {
    const params = this.state.params;
    params.status = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setPrecinct = val => {
    const params = this.state.params;
    params.precincts = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setSensorType = val => {
    const params = this.state.params;
    params.disciplines = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {},
        showIDInput: false
      };
    });
    this.getAllSensors();
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a className="pull-right link" onClick={() => this.resetFilter()}>
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  renderPagination = () => {
    if (!this.state.listLoading && this.state.count > this.state.page_size) {
      return (
        <Pagination
          count={this.state.count}
          page_size={this.state.page_size}
          num_pages={this.state.num_pages}
          current_page={this.state.current_page}
          action={this.filterDevice}
        />
      );
    } else {
      return null;
    }
  };

  renderIdInput = () => {
    if (this.state.showIDInput) {
      return (
        <FormGroup controlId="formBasicText">
          <ControlLabel>ID</ControlLabel>
          <FormControl
            type="text"
            placeholder="Alert ID"
            name="id"
            value={this.state.params.id}
            onChange={this.setId}
          />
        </FormGroup>
      );
    }
  };

  renderMainTitle = data => {
    if (!data) {
      return null;
    }

    return (
      <div className="mainTitle">
        <div className="pull-right btnCon">
          <Link to={"/devicesMap"} onClick={() => this.setCurrentPage(false)}>
            <Button className="btn btn-primary pull-left">
              <FontAwesome name="map" /> Map View
            </Button>
          </Link>
        </div>
        <h1>Devices {"(" + this.state.count + ")"}</h1>
      </div>
    );
  };

  renderMainContent = data => {
    if (!data) {
      return null;
    }

    const deviceCardListToRender = [];
    if (data !== undefined && data.length > 0) {
      _.each(data, (item, key) => {
        deviceCardListToRender.push(this.createDeviceCard(item, key));
      });
    }

    return (
      <div className="mainContent card-list">
        <Row>
          <Col md={3} mdPush={9}>
            <div className={"panel-div filter-column" + (this.state.filterOpen ? " filterOpen" : "")}>
              <div className="filterTitle">FILTER DEVICES {this.renderResetBtn()}</div>
              <form>
                <PrecinctDropdown
                  change={this.setPrecinct}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.precincts}
                />
                <SensorTypeCheckBox
                  change={this.setSensorType}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.disciplines}
                />
                <DeviceStatusCheckBox
                  change={this.setStatus}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.status}
                />
                <div className="buttonContainer">
                  <Button className="btn-cancel" bsStyle="default" onClick={() => this.openFilter(false)}>
                    Cancel
                  </Button>
                  <Button className="btn-filter" bsStyle="primary" onClick={() => this.filterDevice()}>
                    Filter
                  </Button>
                </div>
              </form>
            </div>
          </Col>
          <Col md={9} mdPull={3}>
            <div className="buttonContainer margin-btm filter-btn-con">
              <Button type="button" onClick={() => this.openFilter(true)} bsStyle="primary">
                Filter
              </Button>
            </div>
            {this.state.listLoading ? (
              <div className="empty-list">
                <div className="loading2" />
              </div>
            ) : null}
            <div className={this.state.listLoading ? "hide" : ""}>
              {deviceCardListToRender.length > 0 ? deviceCardListToRender : <div className="empty-list">No Result</div>}
            </div>
            {this.renderPagination()}
          </Col>
        </Row>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  render() {
    const data = this.state.devicesList;
    if (this.state.loading === false) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle(data)}
              {this.renderMainContent(data)}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(
  mapStateToProps,
  {
    sensorList,
    sensorOn,
    sidebarOff,
    pageDevices,
    modalAlert
  }
)(AllSensorPage);



// WEBPACK FOOTER //
// ./src/_components/AllSensorPage/index.js